import { DatePipe } from '@angular/common';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CalendarOptions } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AlertService } from 'src/app/services/alert.service';
import { BidderService } from 'src/app/services/bidder.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog.service';
import { NotifyService } from 'src/app/services/notify.service';

@Component({
    selector: 'app-auction-scheduler',
    templateUrl: './auction-scheduler.component.html',
    styleUrls: ['./auction-scheduler.component.css'],
    providers: [DatePipe],
    standalone: false
})
export class AuctionSchedulerComponent implements OnInit {
  userId: string;
  bidderid: number;
  currentUser: any;
  roleName: string;
  public modalAuctionDetailsRef: BsModalRef;
  @ViewChild('templateAuctionDetails', { read: TemplateRef }) templateAuctionDetails: TemplateRef<any>;
  calendarOptions: CalendarOptions = {
    plugins: [dayGridPlugin, interactionPlugin],
    initialView: 'dayGridMonth',
    dateClick: this.handleDateClick.bind(this), // bind is important!
    // eventContent: { html: '<i>some html</i>' },
    eventClick: this.handleEventDateClick.bind(this),
    eventColor: '',
    eventBackgroundColor : '',
    // eventTextColor: '#000',
    // eventDisplay: 'list-item',
    eventOverlap: false,
    headerToolbar: {
      right: "dayGridMonth,dayGridWeek,dayGridDay",
      center: "title",
      left: "prevYear,prev,next,nextYear"
    },
    expandRows: true
  };

  CurrentAuctionList = [];
  UpcomingAuctionList = [];
  filterRecord: any;
  auctionDateId: number;
  public config = {
    animated: true,
    keyboard: false,
    backdrop: true,
    ignoreBackdropClick: true
  };
  constructor(
    private _alertService: AlertService,
    private confirmDialogService: ConfirmDialogService,
    public notifyservice: NotifyService,
    private _bidderService: BidderService,
    public datepipe: DatePipe,
    private modalService: BsModalService,    
    private router: Router) { }

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    if (this.currentUser) {
      this.roleName = this.currentUser.rolename;
      this.userId = this.currentUser.userid;
      this.bidderid = this.currentUser.bidderid;
      this.getBidderDashboard(this.bidderid);
    }
  }

  getBidderDashboard(bidderid) {
    this.UpcomingAuctionList = [];
    this.CurrentAuctionList = [];
    let eventObj = {};
    let events = [];
    this._bidderService.getBidderDashboard(null, this.bidderid, false, null).subscribe(results => {
      this.CurrentAuctionList = results[1];
      for (let index = 0; index < this.CurrentAuctionList.length; index++) {
        const element = this.CurrentAuctionList[index];
        eventObj = {
          title: 'Total Vehicles: ' + element?.VehicleCount +'\n Location: ' + element.StorageLocationName + ' ' + element.StorageLocationAddress + '\n Seller: ' + element.EnterpriseName, 
          date: this.datepipe.transform(element.StartDate, 'yyyy-MM-dd')
        }
        // // , start: this.datepipe.transform(element.StartDate, 'yyyy-MM-dd'), end: this.datepipe.transform(element.EndDate, 'yyyy-MM-dd')
        events.push(eventObj);
        //const element = this.CurrentAuctionList[index];
        // eventObj = {
        //   title: 'Total Vehicles: ' + element?.VehicleCount,
        //   date: this.datepipe.transform(element.StartDate, 'yyyy-MM-dd')
        // }        
        
        // events.push(eventObj);
        // eventObj = {
        //   title: 'Location: ' + element.StorageLocationName, 
        //   date: this.datepipe.transform(element.StartDate, 'yyyy-MM-dd')
        // }      
        // events.push(eventObj);
       
        // eventObj = {
        //   title: 'Seller: ' + element.EnterpriseName,
        //   date: this.datepipe.transform(element.StartDate, 'yyyy-MM-dd')
        // }
        // events.push(eventObj);
      }

      this.UpcomingAuctionList = results[0];
      for (let index = 0; index < this.UpcomingAuctionList.length; index++) {
        const element = this.UpcomingAuctionList[index];
        eventObj = {
          title: 'Total Vehicles: ' + element?.VehicleCount +'\n Location: ' + element.StorageLocationName + ' ' + element.StorageLocationAddress + '\n Seller: ' + element.EnterpriseName, 
          date: this.datepipe.transform(element.StartDate, 'yyyy-MM-dd')
        }
        events.push(eventObj);
      }

      if (events.length > 0) {
        this.calendarOptions.events = events;
      }
    },
      (error) => {
        console.log(error);
      });
  }

  handleDateClick(arg) {
    console.log(arg);
    console.log('date click! ' + arg.dateStr)
    if (arg.dateStr) {
      this.filterRecord = this.CurrentAuctionList.filter(x => this.datepipe.transform(x.StartDate, 'yyyy-MM-dd') == arg.dateStr)[0];
      console.log(this.filterRecord);
      if (this.filterRecord) {
        this.auctionDateId = this.filterRecord?.AuctionDateId;
  
        this.openAuctionDetailsModal(this.templateAuctionDetails);
      }
      else{
        this.filterRecord = this.UpcomingAuctionList.filter(x => this.datepipe.transform(x.StartDate, 'yyyy-MM-dd') == arg.dateStr)[0];
        console.log(this.filterRecord);
        if (this.filterRecord) {
          this.auctionDateId = this.filterRecord?.AuctionDateId;
    
          this.openAuctionDetailsModal(this.templateAuctionDetails);
        } 
      }
    }
  }

  handleEventDateClick(arg) {
    console.log(arg);
    console.log('Event click! ' + arg.event.startStr)
    if (arg.event.startStr) {
      this.filterRecord = this.CurrentAuctionList.filter(x => this.datepipe.transform(x.StartDate, 'yyyy-MM-dd') == arg.event.startStr)[0];
      // console.log(this.filterRecord);
      if (this.filterRecord) {
        this.auctionDateId = this.filterRecord?.AuctionDateId;
  
        this.openAuctionDetailsModal(this.templateAuctionDetails);
      }
      else {
        this.filterRecord = this.UpcomingAuctionList.filter(x => this.datepipe.transform(x.StartDate, 'yyyy-MM-dd') == arg.event.startStr)[0];
        // console.log(this.filterRecord);
        if (this.filterRecord) {
          this.auctionDateId = this.filterRecord?.AuctionDateId;
    
          this.openAuctionDetailsModal(this.templateAuctionDetails);
        }
      }
    }
  }

  closeModal() {
    this.modalAuctionDetailsRef.hide();
  }

  openAuctionDetailsModal(template: TemplateRef<any>) {
    this.modalAuctionDetailsRef = this.modalService.show(template, Object.assign({}, this.config, { class: 'gray modal-lg', backdrop: 'static' }));
  }

  continue() {
    this.modalAuctionDetailsRef.hide();
    let item = this.filterRecord;
    this.router.navigate(['searchdetails'], {
      state: {
        enterpriseId: item.EnterpriseId,
        makeId: '',
        modelId: '',
        styleId: '',
        colorId: '',
        fromYear: '',
        toYear: '',
        adateId: item.AuctionDateId,
        storageLotId: item.StorageLotId
      }
    });
  }
}
